<template>
    <el-dialog
        :visible.sync="show"
        append-to-body
        custom-class="gcmcn-modal"
        :close-on-click-modal="closeOnClickModal"
        :show-close="false"
        @close="handleClose"
        :style="{height: height > 0 ? height+'px' : 'auto'}"
    >
        <slot></slot>
    </el-dialog>
</template>

<script>

export default {

    components: {

    },

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        closeOnClickModal: {
            type: Boolean,
            default: true,
        },
        height: {
            type: Number,
            default: 542,
        },
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        handleClose (){
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.gcmcn-modal{
    width: 690px  !important;
    background: linear-gradient(180deg, #111111 12.5%, #222222 100%) !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 5px !important;
    text-transform: uppercase;
    .el-dialog__header{
        padding: 0;
    }
    .el-dialog__body{
        height: 100%;
        padding: 30px 40px;
    }
    .gcmcn-modal-header{
        margin-bottom: 37px;
        .gcmcn-modal-title-container{
            margin-bottom: 8px;
        }
        .gcmcn-modal-title{
            font-size: 18px;
            font-weight: bold;
            font-family: roboto;
            color: #bbb;
        }
        .gcmcn-modal-title-light{
            font-size: 18px;
            font-family: roboto-thin;
            color: #bbb;
        }
        .feed-info{
            color: #333;
    }
        }
    .gcmcn-modal-body{
        height: 360px;
        color: #E5E5E5;
    }
    .gcmcn-modal-footer{
        display: flex;
        justify-content: space-between;
        button{
            color: #bbb;
        }
        .not-now{
            display: flex;
            margin-left: auto;
        }
        .validate-configuration-btn{
            padding: 8px;
            border-radius: 2px;
            font-size: 12px;
            font-family: roboto;
            line-height: 14px;
            color: #444444;
            height: 30px;
            border: none;
            background-color: #bbbbbb;
            &.is-disabled{
                color: #222222;
                background-color: #333333;
            }
        }

    }
    .help-text{
        text-transform: initial;
        font-family: roboto-thin;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/gcmcn-modal-theme.vue